// extracted by mini-css-extract-plugin
export var closeIcon = "attachment-pill-module--close-icon--252c5";
export var downloadButton = "attachment-pill-module--download-button--e36a2";
export var elements = "attachment-pill-module--elements--4512e";
export var elementsWrapper = "attachment-pill-module--elementsWrapper--b730a";
export var folderWrapper = "attachment-pill-module--folder-wrapper--84855";
export var pillText = "attachment-pill-module--pill-text--e658e";
export var reverseColors = "attachment-pill-module--reverse-colors--33f51";
export var wrapper = "attachment-pill-module--wrapper--bf0f3";